import { render } from "./nobat.vue?vue&type=template&id=4ca4acfa"
import script from "./nobat.vue?vue&type=script&lang=js"
export * from "./nobat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-kiosk-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__